//@ts-nocheck
import React from 'react';
import { Card, Table } from 'react-bootstrap';
import {
  calculateReceivedTotalItems,
  calculateReceivedTotalValue,
} from '../utils/orderUtils';

const OrderItemsTable = ({
  order,
  calculateTotalValue,
  calculateTotalItems,
}) => {
  const isReceived =
    order.status === 'completed' || order.status === 'odebrano';

  return (
    <Card>
      <Card.Header>
        <h6 className="mb-0">Pozycje zamówienia</h6>
      </Card.Header>
      <Card.Body>
        <div className="table-responsive">
          <Table striped bordered>
            <thead>
              <tr>
                <th style={{ width: isReceived ? '20%' : '30%' }}>
                  Nazwa
                </th>
                <th style={{ width: isReceived ? '12%' : '20%' }}>Typ</th>
                <th style={{ width: isReceived ? '13%' : '20%' }}>
                  Cena jednostkowa
                </th>
                <th style={{ width: isReceived ? '8%' : '15%' }}>Ilość</th>
                <th style={{ width: isReceived ? '12%' : '15%' }}>
                  Wartość
                </th>
                {isReceived && (
                  <>
                    <th style={{ width: '10%' }}>Odebrana ilość</th>
                    <th style={{ width: '13%' }}>Rzeczywista cena</th>
                    <th style={{ width: '12%' }}>Rzeczywista wartość</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {order.items?.map((item, index) => {
                const actualValue =
                  (item.receivedQuantity || 0) *
                  (item.actualUnitPrice || 0);
                const priceDifferenceClass =
                  isReceived && item.actualUnitPrice
                    ? item.actualUnitPrice > item.unitPrice
                      ? 'text-danger'
                      : item.actualUnitPrice < item.unitPrice
                      ? 'text-success'
                      : ''
                    : '';

                // Zabezpieczenie przed undefined item.item
                const itemInfo = item.item || {};

                return (
                  <tr key={index}>
                    <td>{itemInfo.name || 'Nieznany produkt'}</td>
                    <td>{itemInfo.type || '-'}</td>
                    <td className="text-end">
                      {item.unitPrice?.toFixed(2)} zł
                    </td>
                    <td className="text-center">{item.quantity} szt.</td>
                    <td className="text-end">
                      <strong>
                        {(item.quantity * item.unitPrice).toFixed(2)} zł
                      </strong>
                    </td>
                    {isReceived && (
                      <>
                        <td className="text-center">
                          {item.receivedQuantity || 0} szt.
                        </td>
                        <td className={`text-end ${priceDifferenceClass}`}>
                          <strong>
                            {(item.actualUnitPrice || 0).toFixed(2)} zł
                          </strong>
                        </td>
                        <td className={`text-end ${priceDifferenceClass}`}>
                          <strong>{actualValue.toFixed(2)} zł</strong>
                        </td>
                      </>
                    )}
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr className="table-info">
                <td colSpan={isReceived ? '3' : '3'} className="text-end">
                  <strong>Razem:</strong>
                </td>
                <td className="text-center">
                  <strong>{calculateTotalItems()} szt.</strong>
                </td>
                <td className="text-end">
                  <strong>{calculateTotalValue().toFixed(2)} zł</strong>
                </td>
                {isReceived && (
                  <>
                    <td className="text-center">
                      <strong>
                        {calculateReceivedTotalItems(order.items)} szt.
                      </strong>
                    </td>
                    <td></td>
                    <td className="text-end">
                      <strong>
                        {calculateReceivedTotalValue(order.items).toFixed(
                          2,
                        )}{' '}
                        zł
                      </strong>
                    </td>
                  </>
                )}
              </tr>
            </tfoot>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default OrderItemsTable;
